export default __webpack_public_path__ + "static/14wisniewski-f0a8765a382d160fcd5e3a16731a4a94.png";